<template>
  <v-card elevation="0" class="pa-2">
    <vue-table
      :data="transactionData"
      :headers="headers"
      :loading.sync="loading"
      :props.sync="tableProps"
      @change="onPagination"
    >
      <template v-slot:filters="{ props }">
        <v-row>
          <v-col cols="12" md="6" lg="3">
            <v-combobox
              :items="page"
              :label="`تعداد نمایش`"
              append-icon="mdi-chevron-down"
              dense
              outlined
              v-model="props.length"
            ></v-combobox>
          </v-col>
          <v-col cols="12" md="6" lg="3">
            <v-combobox
              :items="services"
              :label="`سرویس`"
              append-icon="mdi-chevron-down"
              dense
              outlined
            ></v-combobox>
          </v-col>
          <!-- <v-col cols="12" md="6" lg="3">
            <date-picker
              v-model="time.start_time"
              clearable
              display-format="jYYYY-jMM-jDD"
              format="YYYY-MM-DD"
              label="از تاریخ"
            />
          </v-col> -->
          <!-- <v-col cols="12" md="6" lg="3">
            <date-picker
              v-model="time.end_time"
              clearable
              display-format="jYYYY-jMM-jDD"
              format="YYYY-MM-DD"
              label="تا تاریخ"
            />
          </v-col> -->
        </v-row>
      </template>

      <template v-slot:index="{ item }">
        {{ transactionData.data.findIndex((data) => data.id == item.id) + 1 }}
      </template>
      <template v-slot:price="{ item }">
        <v-btn
          color="#f28b82
"
          class="white--text"
          elevation="0"
          width="100px"
        >
          {{ item.price.toLocaleString() }}
        </v-btn>
      </template>
      <template v-slot:type="{ item }">
        <v-btn
          color="#a0c8e8"
          class="white--text"
          flt
          elevation="0"
          width="100px"
          >{{ showType(item.type) }}</v-btn
        >
      </template>
      <template v-slot:time="{ item }">
        {{ item.time }}
      </template>
      <template v-slot:fine="{ item }">
        {{ item.fine }}
      </template>
      <template v-slot:description="{ item }">
        {{ item.description }}
      </template>
      <template v-slot:action="{ item }">
        <v-btn
          small
          color="primary"
          outlined
          @click="
            gate = true;
            gateSetting.inf = item;
          "
          >پرداخت
          <v-icon class="mr-2">mdi-cash</v-icon>
        </v-btn>
      </template>
    </vue-table>

    <custom-popup maxWidth="600px" v-model="gate" :cons="{ title: 'پرداخت' }">
      <v-stepper v-model="e1">
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-row
              class="w-100 pa-2 d-flex flex-column align-items-center justify-content-center"
            >
              <v-col cols="12">
                <v-card
                  @click="switchGateType('gate')"
                  :elevation="gateType === 'gate' ? 3 : 0"
                  class="w-100 d-flex align-items-center justify-content-around"
                  :class="gateType === 'gate' ? '' : 'border'"
                  rounded="xl"
                  style="cursor: pointer"
                >
                  <v-avatar>
                    <v-icon>mdi-account-credit-card-outline</v-icon>
                  </v-avatar>

                  <v-card-title>پرداخت از طریق درگاه های عضو شتاب</v-card-title>
                  <v-card-action v-if="gateType === 'gate'">
                    <v-icon color="green">mdi-check-circle-outline</v-icon>
                  </v-card-action>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card
                  :elevation="gateType === 'card' ? 3 : 0"
                  class="w-100 d-flex align-items-center justify-content-around border align-items-center"
                  rounded="xl"
                  style="cursor: pointer"
                  @click="switchGateType('card')"
                >
                  <v-avatar>
                    <v-icon>mdi-credit-card-multiple</v-icon>
                  </v-avatar>

                  <v-card-title> کارت به کارت </v-card-title>
                  <v-card-action v-if="gateType === 'card'">
                    <v-icon color="green">mdi-check-circle-outline</v-icon>
                  </v-card-action>
                </v-card>
              </v-col>
              <v-col cols="12" class="d-flex justify-content-end">
                <v-btn
                  @click="e1 = 2"
                  :disabled="gateType.length == 0"
                  outlined
                  color="green"
                >
                  ادامه
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-stepper-content>
          <v-stepper-content step="2">
            <div class="pa-2">
              <select-gate-slaes v-model="gateSetting.gate" />
              <div
                class="w-100 d-flex justify-content-between align-items-center"
              >
                <v-btn outlined color="red" @click="e1 = 1">
                  <v-icon>mdi-chevron-right</v-icon>
                  بازگشت
                </v-btn>
                <v-btn
                  :disabled="Object.keys(gateSetting.gate).length == 0"
                  outlined
                  color="green"
                  @click="e1 = 3"
                >
                  ادامه
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
              </div>
            </div>
          </v-stepper-content>
          <v-stepper-content step="3">
            <div class="pa-2">
              <v-card elevation="2" rounded="xl">
                <v-card-title>
                  مبلغ قابل پرداخت :
                  {{ gateSetting?.inf?.price?.toLocaleString() }} ﷼
                </v-card-title>
              </v-card>
              <v-col cols="12" class="d-flex justify-content-between">
                <v-btn outlined @click="e1 = 2" color="red">
                  <v-icon>mdi-chevron-right</v-icon>
                  بازگشت
                </v-btn>
                <v-btn outlined color="green">
                  پرداخت
                  <v-icon>mdi-credit-card-multiple</v-icon>
                </v-btn>
              </v-col>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </custom-popup>
  </v-card>
</template>

<script>
import selectGateSlaes from "../../components/gate/selectGateSlaes.vue";

export default {
  components: { selectGateSlaes },
  // داده دارد
  name: "commercialListItemTwoPay",
  data() {
    return {
      page: ["10", "20", "30", "40", "50"],
      loading: false,
      headers: [
        { value: "index", text: "ردیف", sortable: false, align: "center" },
        {
          value: "price",
          text: "مبلغ پرداخت (ریال)",
          sortable: true,
          align: "center",
        },
        { value: "type", text: "سرویس", sortable: false, align: "center" },
        {
          value: "time",
          text: "موعد پرداخت",
          sortable: false,
          align: "center",
        },
        {
          value: "fine",
          text: "جریمه(درصد)",
          sortable: false,
          align: "center",
        },
        {
          value: "description",
          text: "توضیحات",
          sortable: false,
          align: "center",
        },
        { value: "action", text: "عملیات", sortable: false, align: "center" },
      ],
      transactionData: {
        data: [
          {
            index: 1,
            price: 850000,
            time: "1404/05/10",
            fine: "5",
            description: "پرداخت اجاره تیرماه",
            type: "rent",
            action: "",
          },
          {
            index: 2,
            price: 320000,
            time: "1404/05/12",
            fine: "-",
            description: "پرداخت شارژ ",
            type: "charge",
            action: "",
          },
          {
            index: 3,
            price: 980000,
            time: "1404/05/15",
            fine: "2",
            description: "اجاره مرداد  ",
            type: "rent",
            action: "",
          },
          {
            index: 4,
            price: 290000,
            time: "1404/05/20",
            fine: "-",
            description: "پرداخت شارژ ماهانه",
            type: "charge",
            action: "",
          },
          {
            index: 5,
            price: 1100000,
            time: "1404/05/22",
            fine: "10",
            description: "اجاره",
            type: "rent",
            action: "",
          },
        ],
        total: 5,
        page: 1,
        per_page: 10,
      },
      services: [
        { value: "rent", text: "اجاره" },
        { value: "charge", text: "شارژ" },
      ],
      time: {
        start_time: "",
        end_time: "",
      },
      gate: false,
      e1: 1,
      tableProps: {
        search: "",
        length: 10,
        productId: [],
        column: "id",
        dir: "desc",
        page: 1,
      },
      gateType: "", // مقدار اولیه
      gateSetting: {
        type: "",
        gate: {},
        inf: {},
      },
    };
  },

  watch: {
    gateType(val) {
      const newItem = {
        type: val,
        gate: {},
        inf: this.gateSetting.inf,
      };
      this.gateSetting = newItem;
    },
    gate(val) {
      if (!val) {
        this.gateType = "";
        this.e1 = 1;
        this.gateSetting = {
          type: "",
          gate: {},
          inf: {},
        };
      }
    },
  },

  methods: {
    showType(e) {
      switch (e) {
        case "rent":
          return "اجاره";
        case "charge":
          return "شارژ";
        case "banner":
          return "اجاره بنر";
        case "space":
          return "اجاره فضای تبلیغاتی";
      }
    },
    switchGateType(type) {
      this.gateType = this.gateType === type ? "" : type;
    },
  },
};
</script>

<style></style>
